<template>
    <div id="section-block" class="page-blockui">
        <div class="row" id="credit_scores_step">
            <div class="col-xl-12 col-md-12 col-12 mx-auto">
                <power-of-attorney/>
            </div>
        </div>
    </div>
    <div v-if="plans.data.length > 0" class="row pricing-card">
        <div class="col-12 col-sm-offset-2 col-sm-10 col-md-12 col-lg-offset-2 col-lg-10 mx-auto">
            <div class="row match-height">
                <div v-for="plan in plans.data" class="col-12 col-md-4">
                    <div class="card basic-pricing text-center">
                        <div class="card-body d-flex flex-column">
                            <div class="pricing-badge text-left">
                                <div v-if="userStore.user.plan?.id == plan.id" class="badge badge-pill badge-light-primary">Current Plan</div>
                            </div>
                            <h3 class="text-primary">{{ plan.name }}</h3>
                            <div class="annual-plan">
                                <template v-for="currency in plan.currencies">
                                    <div class="plan-price mt-2">
                                        <sup class="font-medium-1 font-weight-bold text-primary mr-50">{{ currency.currency }}</sup>
                                        <span class="pricing-basic-value font-weight-bolder text-primary">{{ currency.unit_amount }}</span>
                                        <sub class="pricing-duration text-body font-medium-1 font-weight-bold"> / {{ plan.interval_length }} {{ plan.interval_unit }}</sub>
                                    </div>
                                    <h4 class="text-primary font-weight-bolder mt-1">One-Time Fee: {{ currency.currency }} {{ currency.setup_fee }}</h4>
                                </template>
                                
                                <span v-html="plan.description" />
                            </div>
                            <button v-if="userStore.user.plan?.id == plan.id" class="btn btn-block btn-primary mt-auto">Current Plan</button>
                            <button v-if="!userStore.user.subscription_id" @click="selectedPlanId = plan.id;openModal(`#${this.id}`);" class="btn btn-block btn-outline-success mt-auto">Purchase</button>
                            <button v-if="userStore.user.plan?.id == plan.id" @click.once="cancelSubscription()" class="btn btn-block btn-outline-danger mt-50" :key="paymentBtnKey">Cancel Subscription</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="col-sm-12">
        <div class="card">
            <div class="card-body">
                <div class="mx-auto">
                    <h3 class="text-center text-warning mb-1">No Plans Are Available at Present.</h3>
                </div>
            </div>
        </div>
    </div>
    <!--/ pricing plan cards -->
    <div class="modal fade" ref="clientPaymentModal" :id="id">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header bg-transparent">
                    <button @click="closeModal('#' + id)" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body px-sm-2 mx-50 pb-5">
                    <h3 class="text-primary text-center mb-1">
                        Subscribe to a Plan
                    </h3>
                    <div v-if="error" class="alert alert-danger" role="alert">
                        <div class="alert-body d-flex align-items-center">
                            <vue-feather type="info" size="14" style="overflow: visible;" class="mr-50 align-middle top-0" />
                            <span v-html="message"></span>
                        </div>
                    </div>
                    <div class="row gy-1 gx-2 mt-75">
                        <div class="col-md-12 col-sm-12">
                            <h4 class="text-primary mb-1">
                                Billing Information
                            </h4>
                        </div>
                        <div class="col-md-12 col-sm-12">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" id="use-profile-information" class="custom-control-input" v-model="useProfileInformation" />
                                <label class="custom-control-label" for="use-profile-information">Use Same Profile Information</label>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <div class="form-group mb-2">
                                <label for="firstname">First Name:</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    :class="{ 'is-invalid': validateBillingInformation.firstname.$error }"
                                    name="firstname"
                                    v-model="billingInformation.firstname"
                                    placeholder="John"
                                />
                                <span v-if="validateBillingInformation.firstname.$error" class="invalid-feedback" role="alert">
                                    <strong>Field is Required</strong>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <div class="form-group mb-2">
                                <label for="lastname">Last Name:</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    :class="{ 'is-invalid': validateBillingInformation.lastname.$error }"
                                    name="lastname"
                                    v-model="billingInformation.lastname"
                                    placeholder="Doe"
                                />
                                <span v-if="validateBillingInformation.lastname.$error" class="invalid-feedback" role="alert">
                                    <strong>Field is Required</strong>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <div class="form-group mb-2">
                                <label for="address">Address (No PO Boxes)</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    :class="{ 'is-invalid': validateBillingInformation.address.$error }"
                                    name="address"
                                    v-model="billingInformation.address"
                                    placeholder="9447 Glen Eagles Drive"
                                />
                                <span v-if="validateBillingInformation.address.$error" class="invalid-feedback" role="alert">
                                    <strong>Field is Required</strong>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <div class="form-group mb-2">
                                <label for="checkout-city">City:</label>
                                <input
                                    type="text"
                                    v-model="billingInformation.city"
                                    class="form-control"
                                    name="city"
                                    placeholder="Tokyo"
                                    :class="{ 'is-invalid': validateBillingInformation.city.$error }"
                                />
                                <span v-if="validateBillingInformation.city.$error" class="invalid-feedback" role="alert">
                                    <strong>Field is Required</strong>
                                </span>
                            </div>
                        </div>        
                        <div class="col-md-6 col-sm-12">
                            <div class="form-group">
                                <label for="state">
                                    State
                                </label>
                                <Select2
                                    v-model="billingInformation.state"
                                    :class="{ 'is-invalid': validateBillingInformation.state.$error }"
                                    :options="stateStore.select2State()"
                                    :settings="{ dropdownParent: $refs.clientPaymentModal }"
                                />
                                <span v-if="validateBillingInformation.state.$error" class="invalid-feedback" role="alert">
                                    <strong>Field is Required</strong>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <div class="form-group mb-2">
                                <label for="zipcode">Zip Code:</label>
                                <input
                                    type="text"
                                    v-model="billingInformation.zipcode"
                                    class="form-control"
                                    name="zipcode"
                                    placeholder="12345"
                                    :class="{ 'is-invalid': validateBillingInformation.zipcode.$error }"
                                />
                                <span v-if="validateBillingInformation.zipcode.$error" class="invalid-feedback" role="alert">
                                    <strong>Field is Required</strong>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <div class="form-group mb-2">
                                <label for="email">Email Address</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="email"
                                    :value="userStore.user.email"
                                    readonly
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row gy-1 gx-2 mt-75">
                        <div class="col-md-6 col-sm-12">
                            <label class="form-label" for="payment-modal-holder-number">
                                {{ localizationStore.translate("card.modal.input.card.number.label") }}
                            </label>
                            <cleave
                                v-model="card.number"
                                :options="{ creditCard: true, delimiter: '-' }"
                                class="form-control"
                                :class="{'is-invalid': validateCard.number.$error}"
                                name="credit-card-number"
                                :placeholder="localizationStore.translate('user.authorized.net.card.input.card.number.placeholder')"
                            />
                            <span v-if="validateCard.number.$error" class="invalid-feedback" role="alert">
                                <strong>Field is Required</strong>
                            </span>
                        </div>

                        <div class="col-6 col-md-3">
                            <label class="form-label" for="payment-modal-expiry-date">
                                {{ localizationStore.translate("card.modal.input.exp.date.label") }}
                            </label>
                            <cleave
                                v-model="card.expiry"
                                :options="{ date: true, delimiter: '-', datePattern: ['m', 'Y'] }"
                                class="form-control"
                                :class="{'is-invalid': validateCard.expiry.$error}"
                                name="expiry"
                                :raw="false"
                                :placeholder="localizationStore.translate('user.authorized.net.card.input.exp.date.placeholder')"
                            />
                            <span v-if="validateCard.expiry.$error" class="invalid-feedback" role="alert">
                                <strong>Field is Required</strong>
                            </span>
                        </div>

                        <div class="col-6 col-md-3">
                            <label class="form-label" for="payment-modal-cvc">
                                {{ localizationStore.translate("card.modal.input.cvc.label") }}
                            </label>
                            <cleave
                                v-model="card.cvc"
                                :options="{ numericOnly: true, blocks: [4] }"
                                class="form-control"
                                :class="{'is-invalid' : validateCard.cvc.$error}"
                                name="card-cvc"
                                :placeholder="localizationStore.translate('user.authorized.net.card.input.cvc.placeholder')"
                            />
                            <span v-if="validateCard.cvc.$error" class="invalid-feedback" role="alert">
                                <strong>Field is Required</strong>
                            </span>
                        </div>

                        <slot name="form-attributes"></slot>
                    </div>
                    <div class="row gy-1 gx-2 mt-75">
                        <div class="col-12 text-center">
                            <button type="button" @click.once="pay()" class="btn btn-primary mr-1 mt-1" :key="paymentBtnKey">
                                Subscribe
                            </button>
                            <button @click="closeModal('#' + id)" type="reset" class="btn btn-outline-secondary mt-1 modal-close-btn" data-dismiss="modal" aria-label="Close">
                                {{ localizationStore.translate("card.modal.button.cancel") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Cleave from 'vue-cleave-component';
    import { ref, reactive } from 'vue';
    import { useClientStore } from "../../stores/ClientStore.js";
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useStateStore } from '../../stores/StateStore.js'
    import { useUserStore } from "../../stores/UserStore.js";
    import { closeModal, openModal, hideModal } from '../../utilities/_helpers'
    import useVuelidate from '@vuelidate/core'
    import { required, email } from '@vuelidate/validators'
    import Select2 from 'vue3-select2-component';
    import Swal from 'sweetalert2'
    import PowerOfAttorney from "./PowerOfAttorney.vue"
    export default {
        components: {
            Cleave,
            Select2,
            PowerOfAttorney
        },
        setup(){
            const card = reactive({
                number: null,
                expiry: null,
                cvc: null,
            });
            const billingInformation = reactive({
                firstname: null,
                lastname: null,
                address: null,
                city: null,
                state: null,
                zipcode: null,
            });
            return {
                closeModal: closeModal,
                clientStore : useClientStore(),
                card: card,
                localizationStore: useLocalizationStore(),
                stateStore: useStateStore(),
                userStore : useUserStore(),
                billingInformation: billingInformation,
                useProfileInformation: ref(false),
                openModal: openModal,
                hideModal: hideModal,
                selectedPlanId: ref(null),
                plans: reactive({
                    data: {}
                }),
                id: 'client-payment-modal',
                paymentBtnKey: ref(1),
                validateCard: useVuelidate(
                    {
                        number: {
                            required
                        },
                        expiry: {
                            required
                        },
                        cvc: {
                            required
                        }
                    },
                    card
                ),
                validateBillingInformation: useVuelidate(
                    {
                        firstname: {
                            required
                        },
                        lastname: {
                            required
                        },
                        address: {
                            required
                        },
                        city: {
                            required
                        },
                        state: {
                            required
                        },
                        zipcode: {
                            required
                        },
                    },
                    billingInformation
                ),
            }
        },
        watch: {
            'useProfileInformation'(value) {
                if (value) {
                    this.billingInformation.firstname = this.userStore.user.firstname;
                    this.billingInformation.lastname = this.userStore.user.lastname;
                    this.billingInformation.address = this.userStore.user.address;
                    this.billingInformation.city = this.userStore.user.city;
                    this.billingInformation.state = this.userStore.user.state;
                    this.billingInformation.zipcode = this.userStore.user.zipcode;
                }
                else {
                    this.resetForm(this.billingInformation);
                }
            },
        },
        mounted(){
            this.getPlans();
        },
        methods:{
            cancelSubscription() {
                const $this = this;
                Swal.fire({
                    title: this.localizationStore.translate('are.you.sure'),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes!',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    buttonsStyling: false
                }).then(function (result) {
                    if (result.value) {
                        const route = $this.$router.resolve(
                            {
                                name: 'client-subscription-terminate'
                            }
                        );
                        axios.post(route.href)
                        .then(function (response) {
                            $this.paymentBtnKey++;
                            if(response.data.error == true) {
                                toastr.error(response.data.message, 'Error!');
                                return;
                            }
                            $this.userStore.user.plan = response.data.data.plan;
                            $this.userStore.user.subscription_id = response.data.data.subscription_id;
                            toastr.success(response.data.message, 'Success!');
                        })
                        .catch(function (error) {
                            $this.paymentBtnKey++;
                            console.log(error);
                        });
                    }
                }); 
            },
            getPlans() {
                const $this = this;
                const route = this.$router.resolve(
                    {
                        name: 'client-plans'
                    }
                );
                axios.post(route.href)
                .then(function (response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    Object.assign($this.plans, response.data.data);
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            async pay() {
                const isValidCard = await this.validateCard.$validate();
                const isValidBillingInformation = await this.validateBillingInformation.$validate();
                if (isValidCard && isValidBillingInformation) {
                    const $this = this;
                    const route = this.$router.resolve(
                        {
                            name: 'client-subscribe'
                        }
                    );
                    axios.post(
                        route.href,
                        {
                            plan_id: $this.selectedPlanId,
                            card: $this.card,
                            billing_information: $this.billingInformation,
                        }
                    )
                    .then(function (response) {
                        $this.paymentBtnKey++;
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        $this.userStore.fetchUser();
                        $this.hideModal(`#${$this.id}`);
                        $this.resetForm("billingInformation");
                        $this.resetForm("card");
                        toastr.success(response.data.message, 'Success!');
                    })
                    .catch(function (error) {
                        $this.paymentBtnKey++;
                        console.log(error);
                    });
                }
                else {
                    this.paymentBtnKey++;
                }
            },
            resetForm(form) {
                const $this = this;
                _.forEach(this[form], function(value, key) {
                    $this[form][key] = null;
                });
                $this.validateCard.$reset();
                $this.validateBillingInformation.$reset();
            }
        }
    }
</script>